import React from 'react';
import PropTypes from 'prop-types';
import Parser from "html-react-parser";

import './style.scss';

const AboutFunc = ({ title, text, link }) => {

  return (
    <div className={"about-smart"}>
      <div className={"about-smart__title"}>
        <h3>{Parser(title)}</h3>
        <a href={link}
           target={"_blank"}
           rel={"noopener noreferrer"}
           className={"about-smart__button"}>{text}</a>
      </div>
    </div>
  );

};

AboutFunc.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default AboutFunc;
